import { numConvert } from "@/method";
import { setKarte } from '@/method/analysis';
import request from '@/method/request';
import _ from 'lodash';

export const getChart = async year => {

    const { data: { data = [], area = [], last = [] } } = await request(`/chartData7_5_1?year=${year}`);
    const dataX = new Array(12).fill(1).map((x, i) => `${i + 1}月`);
    setKarte({
        id: "row1",
        title: "年假人均天数",
        color: ['#00C5BD', '#42585D', '#FE5F5F'],
        dataX, dataY: [
            {
                name: "今年",
                data: dataX.map((x, i) => numConvert(_.get(data.find(_x => _x.month == (i + 1)), 'thisy_average_payroll', 0)).toFixed(2))
            },
            {
                name: "去年",
                data: dataX.map((x, i) => numConvert(_.get(data.find(_x => _x.month == (i + 1)), 'lasty_average_payroll', 0)).toFixed(2))
            },
            {
                name: "区域",
                data: dataX.map((x, i) => numConvert(_.get(area.find(_x => _x.month == (i + 1)), 'thisy_average_payroll', 0)).toFixed(2))
            }
        ]
    });

}

export const getChart2 = async year => {

    const { data: { data = [], area = [], last = [] } } = await request(`/chartData7_5_2?year=${year}`);
    const dataX = new Array(12).fill(1).map((x, i) => `${i + 1}月`);
    console.log(data);
    setKarte({
        id: "row2",
        title: "加班人均小时数",
        color: ['#00C5BD', '#42585D', '#FE5F5F'],
        dataX, dataY: [
            {
                name: "今年",
                data: dataX.map((x, i) => numConvert(_.get(data.find(_x => _x.month == (i + 1)), 'year_thisy_average_payroll', 0)).toFixed(2))
            },
            {
                name: "去年",
                data: dataX.map((x, i) => numConvert(_.get(data.find(_x => _x.month == (i + 1)), 'year_lasty_average_payroll', 0)).toFixed(2))
            },
            {
                name: "区域",
                data: dataX.map((x, i) => numConvert(_.get(area.find(_x => _x.month == (i + 1)), 'year_thisy_average_payroll', 0)).toFixed(2))
            }
        ]
    });

}


// WEBPACK FOOTER //
// ./src/components/table/7-HumanResourcesAnalysis/7-5/compute.js